import { Component, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-no-resources',
  templateUrl: './no-resources.component.html',
  styleUrls: ['./no-resources.component.css'],
  imports: [TranslocoPipe],
})
export class NoResourcesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
